import { SkedPlanCodeName } from "../types";

export const possibleSkedPlanCodeNames: SkedPlanCodeName[] = [
  "sked-fundamentals",
  "sked-essentials",
  "sked-professional",
  "sked-enterprise",
  "sked-enterprise-custom",
];

export const planBaseMaxAccounts = {
  "sked-fundamentals": 1,
  "sked-essentials": 3,
  "sked-professional": 6,
  "sked-enterprise": 20,
  "sked-enterprise-custom": 20,
} as const;

export const fundamentalsFeatures = [
  "Unlimited posts",
  "1 account",
  "1 user",
  "Visual Instagram planner",
  "Basic 30 day analytics",
  "AI caption writing",
];

export const essentialsFeatures = [
  "Additional users with account level permissions",
  "Internal comments and tags",
  "Multi-platform scheduling",
  "All-in-one social inbox",
  "AI assistance",
  "Organic and paid analytics",
  "Social listening summaries",
  "Auto-generated reports",
  "Canva, Google Drive and Dropbox integrations",
  "Link-in-bio page",
  "24/7 live chat + onboarding support",
];
export const professionalFeatures = [
  "Frictionless custom approval workflows",
  "No-login branded review portal",
  "Social Listening audience analytics",
  "Content Labels",
  "Competitor analysis",
  "Instant PDF reports",
  "Raw data export",
  "Dedicated customer success manager",
  "Bulk uploads",
];

export const enterpriseFeatures = [
  "Custom PDF reports with editable AI analysis",
  "Content Labels reporting to segment your data simply",
  "Custom comparison periods",
  "Full suite of Social Listening tools",
  "Whitelabeled link-in-bio",
  "Priority support and dedicated customer success manager",
  "Flexible payment terms on annual contracts",
];
